import React from "react";
import useScrollProgress from "../../hooks/useScrollProgress";

/** Fio de progresso no topo da página. */
const ScrollProgress = () => {
  const progress = useScrollProgress();

  return (
    <div
      aria-hidden="true"
      className="fixed inset-x-0 top-0 z-[60] h-[3px] bg-transparent"
    >
      <div
        className="scroll-progress h-full bg-gradient-to-r from-tealVitality via-tealGlow to-pawOrange"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
};

export default ScrollProgress;
